// The three TOC element types whose portfolio link gets a UI badge. Question/
// Output sync rows are deliberately excluded — those pair sub-items, not the
// elements themselves.
const PROJECT_FIELDS = ['ProjectEffect', 'ProjectActivity', 'ProjectTargetgroup'];

/**
 * Builds a lookup of locally-owned TOC elements that are paired to a parent
 * portfolio, from the tenant's Synchronisations rows. Local copies carry no
 * marker themselves — the pairing lives only in these rows.
 * AI-CONTEXT: See docs/features/toc-navigator-add-chooser.md
 *
 * @param {Array<object> | undefined | null} syncRows - Synchronisations docs of the current tenant
 * @returns {Record<string, string>} Map of local element ID → parent portfolio CompagnyID
 */
const buildSyncedLinksMap = (syncRows) => {
    if (!Array.isArray(syncRows)) return {};

    return syncRows.reduce((map, row) => {
        if (row?.Status !== 'paired' || !row?.Parent) return map;

        PROJECT_FIELDS.forEach((field) => {
            // First row wins: useSyncedLinks orders rows newest-first, so on a
            // re-pair the most recent portfolio is the one the badge shows.
            if (row[field] && !(row[field] in map)) map[row[field]] = row.Parent;
        });

        return map;
    }, {});
};

export default buildSyncedLinksMap;
